export default __webpack_public_path__ + "static/media/qr-code.57e18afa.gif";